export function interpolationInTime(msTotal: number, onUpdate: (progress: number) => void, onComplete: () => void) {
    let ms = 0;
    let prev = Date.now();

    const intervalId = setInterval(() => {
        const now = Date.now();
        ms += now - prev;
        prev = now;
        const progress = ms / msTotal;

        if (progress >= 1) {
            clearInterval(intervalId);
            onUpdate(1);
            onComplete();
        } else {
            onUpdate(progress);
        }
    }, 100);

    return {
        stop: () => {
            clearInterval(intervalId);
        },
    };
}
